import {Pipe, PipeTransform} from '@angular/core';
import * as UIModels from '@shared-models/index';

@Pipe({
    name: 'filterBy'
})
export class FilterByPipe implements PipeTransform {

    // tslint:disable: max-line-length
    transform(
        value: Array<UIModels.CM.KeyValue>,
        filterBy: string,
        filterField: string,
        strictFiltering: boolean = true
    ): Array<UIModels.CM.KeyValue> {
        filterBy = filterBy ? filterBy.toLocaleLowerCase() : null;

        if (strictFiltering) {
            // strict match from string start
            const regex = new RegExp(`^${filterBy}`, 'gi');
            return filterBy ? value.filter((item: UIModels.CM.KeyValue) => regex.test(item[filterField])) : value;
        } else {
            return filterBy ? value.filter((item: UIModels.CM.KeyValue) =>
                item[filterField].toLocaleLowerCase().includes(filterBy)) : value;
        }
    }
}
